import { makeStyles, Box, Divider, Grid, Typography, Paper } from '@material-ui/core'
import MyTextfield from '../../../control/textfield/textfield'
import { useForm, useFormState } from 'react-final-form'
import useTranslate from '../../../i18n/useTranslate'
import Radio from '../../../control/radio/radio'
import { textRequired } from '../../../utilities/validate'
import { useEffect } from 'react'
import _ from 'lodash'

export type AgendaForm = {
    round: string
    createdDate: string
    title: string
    meetingDate: string
    startTime: string
    openTime: string
    location: string
    meetingLink: string
    details: string
}

export enum ApprovalStatusId {
    approved = '1',
    rejected = '2',
}

const ApproveAgendaForm: React.FC<{ canEdit?: boolean }> = ({ canEdit = true }) => {
    const t = useTranslate()
    const classes = useStyles()
    const { values } = useFormState<{ [k: string]: any }>({
        subscription: { values: true, invalid: true, submitting: true },
    })
    const form = useForm()

    const option = [
        { name: t.get('UM.SETTING_AGENDA.APPROVE'), id: ApprovalStatusId.approved },
        { name: t.get('UM.SETTING_AGENDA.REJECT'), id: ApprovalStatusId.rejected },
    ]

    let selected = values.submittedStatusId === 11 ? ApprovalStatusId.rejected : String(values?.approvalStatusId)

    useEffect(() => {
        form.change('approvalStatusId', values.submittedStatusId === 11 ? ApprovalStatusId.rejected : null)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values.submittedStatusId])

    return (
        <Paper className={classes.root} elevation={0} style={{ marginBlock: values.submittedStatusId === 11 ? 0 : 20 }}>
            <Box className={classes.headerBar}>
                <Typography variant="h6" style={{ fontWeight: 700 }}>
                    {t.get('UM.SETTING_AGENDA.APPROVAL_RESULT')}
                </Typography>
            </Box>

            <Divider />

            <Box className={classes.section}>
                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        <Radio
                            name="approvalStatusId"
                            options={option}
                            requiredHalfWidth={true}
                            required
                            disabled={!canEdit}
                        />
                    </Grid>

                    {selected === ApprovalStatusId.rejected && (
                        <Grid item xs={12}>
                            <MyTextfield
                                name="remark"
                                materialInputProps={{
                                    label: t.get('LABEL.REMARK'),
                                    placeholder: t.get('LABEL.REMARK'),
                                    multiline: true,
                                    rows: 5,
                                    disabled: !canEdit,
                                }}
                                maxLength={1000}
                                required
                                validates={[textRequired(t.get('MESSAGE.M013'))]}
                            />
                        </Grid>
                    )}
                </Grid>
            </Box>
        </Paper>
    )
}

const useStyles = makeStyles((theme) => ({
    root: { borderRadius: 12, border: '1px solid #E5E7EB', background: '#fff', marginBlock: 20 },
    headerBar: {
        padding: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        fontWeight: 700,
    },
    actionRow: { display: 'flex', gap: 12 },
    section: { padding: theme.spacing(3) },
}))

export default ApproveAgendaForm
